import { render, staticRenderFns } from "./NewsDescription.vue?vue&type=template&id=0bb77660&"
import script from "./NewsDescription.vue?vue&type=script&lang=js&"
export * from "./NewsDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports